// @flow
import React from 'react';

import { searchExact } from 'Api'

import Layout from 'pages/Avila/Dessin/List/layout_find'

import SearchModal from './SearchModal';
import type { Props as SearchModalProps } from './SearchModal'

type Props = {
    onClose: any => any,
    actions: Array<any>,
    filterData: Array<any>
}
export default ({
    onClose,
    actions = [],
    filterData = [],
}: Props & SearchModalProps) => {

    return (
        <SearchModal
            title={"Ajouter un dessin"} onClose={onClose}
            actions={actions}
            filterData={filterData}
            searchFunction={async query => {

                const expos = await searchExact({
                    type: 'dessin',
                    query
                });

                return expos;
            }}
            renderList={({ data, actions }) => {

                return (
                    <Layout data={data} filterData={filterData} actions={actions} />
                )
            }}
        />
    )
}